import {
  LabeledButton,
  LabeledButtonContent,
  LabeledButtonLabel,
} from "@babackapp/customer-ui/components/button";
import { DateSelect } from "@babackapp/customer-ui/components/date-select";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionContent,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { ChevronsUpDown, MailboxIcon } from "lucide-react";
import { Controller, type Control } from "react-hook-form";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

type FormValues = {
  returnMode: string;
  pickupDate?: string;
  storeId?: string;
};

type Props = {
  control: Control<FormValues>;
  selected: boolean;
  error?: string;
};

export function CarrierOption({ control, selected, error }: Props) {
  const t = useCustomText();
  return (
    <Label htmlFor="carrier">
      <Option>
        <OptionIcon>
          <MailboxIcon />
        </OptionIcon>
        <OptionTitle>{t("returnMode.carrier.title")}</OptionTitle>
        <OptionDescription>
          {t("returnMode.carrier.description")}
        </OptionDescription>
        <OptionContent>
          {selected && (
            <Controller
              control={control}
              name="pickupDate"
              render={({ field }) => (
                <div className="flex flex-col gap-1 w-full">
                  <DateSelect
                    className="w-full"
                    selected={field.value ? new Date(field.value) : undefined}
                    onSelect={(date) =>
                      field.onChange(date ? date.toISOString().split("T")[0] : undefined)
                    }
                  >
                    <LabeledButton variant="outline" data-invalid={!!error}>
                      <LabeledButtonLabel>{t("returnMode.carrier.pickupDate")}</LabeledButtonLabel>
                      <LabeledButtonContent>
                        {field.value
                          ? new Date(field.value).toLocaleDateString("fr-FR")
                          : t("returnMode.carrier.noDateSelected")}
                      </LabeledButtonContent>
                      <ChevronsUpDown />
                    </LabeledButton>
                  </DateSelect>
                  {error && (
                    <p className="text-sm text-destructive">{t("returnMode.carrier.pickupDateRequired")}</p>
                  )}
                </div>
              )}
            />
          )}
        </OptionContent>
        <OptionAction>
          <RadioGroupItem value="carrier" id="carrier" />
        </OptionAction>
      </Option>
    </Label>
  );
}
